import {
  CustomMutation, Request,
  UpdateMultiple,
} from '@/composables/GraphQL';
import {
  CampaignsAutomationBase,
  CampaignsAutomationUpdateInputItem,
  CampaignsAutomationDuplicateInputItem,
  CampaignsAutomationSaveInputItem,
} from '@/types/generated-types/graphql';
import { NestApiType, nestCall } from '@/composables/nestApi';

export async function updateMultipleCampaignsAutomation(workflowInput: CampaignsAutomationUpdateInputItem[]) {
  const {
    id, messages, err,
  } = await UpdateMultiple<CampaignsAutomationUpdateInputItem>({
    name: 'CampaignsAutomation',
    input: workflowInput,
    type: 'CampaignsAutomationUpdateInput',
  });

  if (err === '') {
    return id;
  }
  return messages;
}

export async function saveWorkflow(workflowSaveInput: CampaignsAutomationSaveInputItem) {
  const {
    id, messages, err,
  } = await CustomMutation<CampaignsAutomationSaveInputItem>({
    name: 'SaveCampaignsAutomation',
    input: workflowSaveInput,
    type: 'CampaignsAutomationSaveInput',
  });

  if (err === '') {
    return {
      success: true,
      id,
    };
  }

  return {
    success: false,
    messages,
  };
}

export async function duplicateWorkflow(workflowToDuplicateInput: CampaignsAutomationDuplicateInputItem) {
  const {
    id, messages, err,
  } = await CustomMutation<CampaignsAutomationDuplicateInputItem>({
    name: 'DuplicateCampaignsAutomation',
    input: workflowToDuplicateInput,
    type: 'CampaignsAutomationDuplicateInput',
  });

  if (err === '') {
    return {
      success: true,
      id,
    };
  }

  return {
    success: false,
    messages,
  };
}

export async function getCampaignsAutomationBaseList(idShop?: number) {
  // `idShop` is forwarded as a query param so the backend can resolve
  // each item's `shop_integration_status` (active / inactive / not_installed)
  // for this specific shop. Legacy calls without idShop still work — items
  // referencing integrations just come back with `shop_integration_status: null`.
  const response = await nestCall(
    'get',
    NestApiType.DEFAULT,
    '/workflow/base-config/campaign_automation_base_list',
    {},
    '',
    undefined,
    true,
    idShop ? { idShop } : {},
  );

  return response?.value || [];
}
